enum SubMenuIndexes {
  HOME = 'menu1',
  NEWS = 'menu2',
  NEWS_CATS = 'menu3',
  NEWS_ADD = 'menu4',
  NEWS_CATEGORY_ADD = 'menu5',
  GALLERY_CATEGORIES = 'menu6',
  GALLERY = 'menu7',
  GALLERY_ADD = 'menu8',
  EXPERT_ARTICLES = 'menu9',
  EXPERT_ARTICLES_ADD = 'menu10',
  EXPERT_ARTICLES_CATEGORY_ADD = 'menu11',
  EXPERT_ARTICLES_CATEGORIES = 'menu12',
  USERS_ADD_USER = 'menu13',
  KNOWLEDGE = 'menu14',
  KNOWLEDGE_ADD = 'menu15',
  USERS = 'menu16',
  VIDEO = 'menu17',
  VIDEO_ADD = 'menu18',
  PRODUCTS = 'menu19',
  PRODUCTS_ADD = 'menu27',
  MULTIMEDIA_ADD = 'menu20',
  MULTIMEDIA = 'menu21',
  LEXICON = 'menu23',
  LEXICON_ADD = 'menu24',
  LEXICON_CATEGORIES = 'menu25',
  LEXICON_CATEGORIES_ADD = 'menu26',
  PRODUCTS_CATEGORIES = 'menu28',
  PRODUCTS_CATEGORIES_ADD = 'menu29',
  FIELD_NEWS = 'menu30',
  FIELD_NEWS_ADD = 'menu31',
  NAWOZY_TV = 'menu32',
  NAWOZY_TV_ADD = 'menu33',
  ALL_CATEGORY_ADD = 'menu34',
  ALL_CATEGORY_LIST = 'menu35',
  SECTION_ADD = 'menu36',
  SECTION_LIST = 'menu37',
  REPRESENTATIVES_LIST = 'menu38',
  REPRESENTATIVES_ADD = 'menu39',
  DISTRIBUTION_LIST = 'menu40',
  DISTRIBUTION_ADD = 'menu41',
  DATA_PROTECTION = 'menu42',
  PRIVACY = 'menu43',
  RULES = 'menu44',
  SERVICE_MAP = 'menu45',
  PASSWORD_CHANGE = 'menu46',
  FERTILIZATION_ADD = 'menu47',
  FERTILIZATION = 'menu48',
  FERTILIZATION_SCHEDULE_ADD = 'menu49',
  FERTILIZATION_SCHEDULE = 'menu50',
  BANNERS = 'menu51',
  ASK_EXPERT = 'menu52',
  ASK_EXPERT_ADD = 'menu53',
  FERTILIZERS_CATEGORIES_ADD = 'menu54',
  FERTILIZERS_CATEGORIES = 'menu55',
  FERTILIZERS_PACK_ADD = 'menu56',
  FERTILIZERS_PACK = 'menu57',
  FERTILIZERS_ADD = 'menu58',
  FERTILIZERS = 'menu59',
  FERTILIZERS_PARAMETERS_ADD = 'menu60',
  FERTILIZERS_PARAMETERS = 'menu61',
  GTW_ARTICLES_ADD = 'menu62',
  GTW_CAT_ADD = 'menu63',
  GTW_CAT = 'menu64',
  GTW_ARTICLES = 'menu65',
  GTW_REQUIREMENTS = 'menu66',
  GTW_REQUIREMENTS_ADD = 'menu67',
  GTW_FILES_ADD = 'menu68',
  GTW_FILES = 'menu69',
  GTW_EDITIONS_ADD = 'menu70',
  GTW_EDITIONS = 'menu71',
  AGRO_LIDER = 'menu72',
  AGRO_LIDER_ADD = 'menu73',
  FERTILIZERS_DICTIONARY = 'menu74',
  GARDEN_EXPERT_ARTICLES = 'menu75',
  GARDEN_EXPERT_ARTICLES_ADD = 'menu76',
  GARDEN_FERTILIZERS = 'menu77',
  GARDEN_FERTILIZERS_ADD = 'menu78',
  GARDEN_FERTILIZERS_DICTIONARY = 'menu79',
}

export default SubMenuIndexes;
